"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bucketListItemByDay = void 0;
var moment_1 = __importDefault(require("moment"));
function bucketListItemByDay(items, dateKey) {
    var map = {};
    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
        var item = items_1[_i];
        var startOfDay = (0, moment_1.default)(item[dateKey]).startOf('day').toISOString();
        if (startOfDay in map) {
            map[startOfDay].push(item);
        }
        else {
            map[startOfDay] = [item];
        }
    }
    return map;
}
exports.bucketListItemByDay = bucketListItemByDay;
